import axios from 'axios';

export const MOVE_LEAD = 'MOVE_LEAD';
export const MOVE_LEAD_LIST_STORE = 'MOVE_LEAD_LIST_STORE';

export const WATCH_LEAD = 'WATCH_LEAD';
export const UNWATCH_LEAD = 'UNWATCH_LEAD';

// send request to the server to update current stage property
export function moveLead(leadId, newStage) {
  return {
    type: MOVE_LEAD,
    payload: axios.post('/api/leads/' + leadId + '/stage.json?_locale=' + globalLocale, { newStage }),
  };
}

// move the lead inside a store
export function moveLeadListStore(leadId, newStage) {
  return {
    type: MOVE_LEAD_LIST_STORE,
    payload: { leadId, currentStage: newStage },
  };
}

export function watchLead(leadId) {
  return {
    type: WATCH_LEAD,
    payload: axios.get('/api/leads/' + leadId + '/watch.json?_locale=' + globalLocale),
  };
}

export function unwatchLead(leadId) {
  return {
    type: UNWATCH_LEAD,
    payload: axios.get('/api/leads/' + leadId + '/unwatch.json?_locale=' + globalLocale),
  };
}

